import { LinearProgress, styled } from "@mui/material";

type Props = {
  isLoading: boolean;
};
export function TableLoadingIndicator({ isLoading }: Props) {
  if (isLoading !== true) {
    return null;
  }

  return (
    <tr>
      <StyledTd>
        <LinearProgress />
      </StyledTd>
    </tr>
  );
}

const StyledTd = styled("td")({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  padding: 0,
});
